
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as UserPairsIconComponent } from "./user-pairs-icon.svg";

export const UserPairsIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <UserPairsIconComponent {...props} />;
};
